exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modulelayout[data-v-6f8a3186]{margin-bottom:36px;display:-ms-grid;display:grid;-ms-grid-rows:auto;grid-template-rows:auto;row-gap:18px}@media screen and (min-width:978px){.modulelayout[data-v-6f8a3186]{padding-top:27px;-ms-grid-columns:300px 1fr;grid-template-columns:300px 1fr;column-gap:40px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6f8a3186","scoped":true,"hasInlineConfig":true}!./node_modules/stylus-loader!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/parts/modules/modulelayout/ModuleLayout.vue
// module id = e57ea65c61e6f7fe49bb
// module chunks = 0